import axios from "axios";
const BASE_URL = "/admin";
const getOwnedTeams = async (year, month) => {
    const result = await axios.get(`${BASE_URL}/teams`);
    return result.data;
};
export { getOwnedTeams };
